import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useFamily } from '../../../context/FamilyContext';
import './ChildView.css';
import TopSectionContainer from './TopSectionContainer';
import AccountCardsContainer from './AccountCardsContainer';
import BottomSectionContainer from './BottomSectionContainer';
import Notification from '../../Notification/Notification';

const NotificationManager = React.memo(({ notification, onClose }) => {
    return (
        <>
            {notification.show && (
                <Notification 
                    message={notification.message} 
                    type="success" 
                    onClose={onClose} 
                />
            )}
        </>
    );
});

const ChildView = React.memo(() => {
    const { childName } = useParams();
    const { selectChildByName, selectedChild, selectedChildName, loading, familyChildren } = useFamily();
    const [notification, setNotification] = useState({ show: false, message: '' });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        console.log("ChildView - childName changed:", childName);
        selectChildByName(childName);
        setIsLoading(true);
    }, [childName, selectChildByName]);

    useEffect(() => {
        if (selectedChildName === childName && selectedChild) {
            console.log("ChildView - selectedChild updated:", selectedChild);
            setIsLoading(false);
        }
    }, [selectedChild, selectedChildName, childName]);

    const notifySuccess = useCallback((message) => {
        setNotification({ show: true, message });
    }, []);

    const handleCloseNotification = useCallback(() => {
        setNotification({ show: false, message: '' });
    }, []);

    const currentChild = useMemo(() => {
        return familyChildren.find(child => child.name === childName) || null;
    }, [familyChildren, childName]);

    const memoizedTopSection = useMemo(() => {
        if (!currentChild) return null;
        return (
            <TopSectionContainer 
                selectedChild={currentChild}
                notifySuccess={notifySuccess}
            />
        );
    }, [currentChild, notifySuccess]);

    const memoizedAccountCards = useMemo(() => {
        if (!currentChild) return null;
        return (
            <AccountCardsContainer 
                childId={currentChild.childId}
                notifySuccess={notifySuccess} 
            />
        );
    }, [currentChild, notifySuccess]);

    if (loading || isLoading) return <div>Loading...</div>;
    if (!currentChild) return <div>Child not found</div>;

    return (
        <div className="child-view-container">
            {memoizedTopSection}
            <div className="middle-section">
                {memoizedAccountCards}
            </div>
            <NotificationManager 
                notification={notification} 
                onClose={handleCloseNotification} 
            />
        </div>
    );
});

export default ChildView;